import { PhaseData } from "../types";

export const calculateGoalTotalAssets = (
  income: number,
  dtaMax: number,
  planMTI: number,
  dscr: number
): number => {
  // New formula: ROUNDUP(annual_income/((DTA x DSCR x MTI)-(DTA*MTI)),3)
  const denominator = (dtaMax * dscr * planMTI) - (dtaMax * planMTI);
  const result = income / denominator;
  // ROUNDUP to nearest hundred
  return Math.ceil(result / 100) * 100;
};

export const calculatePhaseValues = (
  goalTotalAssets: number,
  percent: number,
  phaseData: PhaseData
) => {
  const assets = goalTotalAssets * percent;
  const debt = assets * phaseData.dta;
  const mty = phaseData.dta * phaseData.dscr * phaseData.mti;
  const reserveDollar = ((debt * phaseData.mti) / 12) * phaseData.resMonths;

  return {
    assets,
    debt,
    mty,
    reserveDollar,
  };
};

export const calculateMilestoneAssets = (
  milestoneIncome: number,
  yieldPercent: number,
  intRate: number,
  dta: number
): number => {
  return milestoneIncome / (yieldPercent / 100 - (dta / 100) * (intRate / 100));
};
